import { type Router } from 'vue-router'
import apiCore from '@/plugins/api'

export default function useCheckCredentials(router: Router) {
  router.beforeEach(to => {
    if (!to.meta.authProtected) return

    // Pas d'attente du refresh en cours : sur réseau dégradé il bloquerait le premier rendu.
    if (!apiCore.token) {
      return {
        name: 'login',
        query: {
          redirect: to.path !== '/' ? to.fullPath : undefined
        },
        replace: true
      }
    }
  })
}
